import * as React from 'react';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import { Grid } from '@mui/material';

const CardBox = (props) => {

    const {
        icon = null,
        label = null,
        subLabel = null,
        RoleLabel = null,
        IsFront = false,
        onClick = () => { },
        style = {},
        classCard = ""
    } = props;
    return (
        <Card
            onClick={onClick}
            className={classCard}
            style={{
                height: RoleLabel != null ? '86px' : '64px',
                width: '100%',
                padding: '6px 8px',
                cursor: 'pointer',
                borderRadius: '10px',
                ...style
            }}
        >
            <Grid container spacing={1} direction="row" justifyContent="space-evenly" alignItems="center">
                <Grid item xs={3}>
                    <Grid container justifyContent="center">
                        <Grid item>
                            {icon}
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={'auto'} justifyContent="start">
                    <Grid container direction="column">
                        <Grid item xs={12}>
                            <Typography   style={{ fontWeight: 700 }}>
                                {label}
                            </Typography>
                        </Grid>
                        {
                            subLabel != null
                                ?
                                <Grid item xs={12}>
                                    <Typography  >
                                        {subLabel}
                                    </Typography>
                                </Grid>
                                : null
                        }
                        {
                            RoleLabel != null
                                ?
                                <Grid item xs={12}>
                                    <Typography gutterBottom >
                                        {RoleLabel}
                                    </Typography>
                                </Grid>
                                : null
                        }
                    </Grid>
                </Grid>
            </Grid>
        </Card>
    )
}

export default CardBox